import { createFileRoute } from '@tanstack/react-router'
import { Suspense } from 'react'
import { SignUp } from '@/components/auth/signup/sign-up'
import GenieLogo from '@/components/ui/icon/icons/GenieLogo'
import { z } from 'zod'
import { zodValidator } from '@tanstack/zod-adapter'

export const Route = createFileRoute('/_auth/signup')({
  validateSearch: zodValidator(z.object({ redirect: z.string().optional() })),
  component: SignUpPage,
})

function SignUpPage() {
  return (
    <Suspense
      fallback={
        <div className="flex min-h-screen items-center justify-center">
          <div className="text-center flex flex-col items-center">
            <GenieLogo className="mb-6 h-12 w-12" />
            <p className="mb-4">Loading...</p>
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-foreground"></div>
          </div>
        </div>
      }
    >
      <SignUp />
    </Suspense>
  )
}
